export const LocaleTypes = ['ru', 'en'] as const;
